import * as actionTypes from "../../../actions/fulfillment/types";

const INITIAL_STATE = {
  fetching: false,
  error: null,
};

export default function (state = INITIAL_STATE, action) {
  const { WRO_POST_REQUESTED, WRO_POST_SUCCESS, WRO_POST_ERRORED, WRO_STEP_PACKING_SLIPS_MODIFIED } = actionTypes;

  switch (action.type) {
    case WRO_POST_REQUESTED:
      return { ...state, fetching: true };
    case WRO_POST_SUCCESS:
      return { ...state, fetching: false, error: null };
    case WRO_POST_ERRORED:
      return { ...state, fetching: false, error: action.error };
    case WRO_STEP_PACKING_SLIPS_MODIFIED:
      return { ...state, error: null };
    default:
      return state;
  }
}
